import React, { useRef, useState } from "react";
import styles from "../Component/ScheduleDemoSty.module.css";
import { HiOutlineMail } from "react-icons/hi";
import { LuCalendar, LuPhone } from "react-icons/lu";
import { useHistory } from "react-router-dom";

export default function ScheduleDemo() {
  const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

  const inputRef = useRef();
  const history = useHistory();

  const [formData, setFormData] = useState({
    demo_reciever_email: "",
    demo_time: "",
    phone_no:""
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");

    if (!formData.demo_reciever_email || !formData.demo_time || !formData.phone_no) {
      setError("Please fill in all required fields.");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(
        `https://scheduledemo2.${backend_api_base_url}/add`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();
      console.log("Response from /add API:", data);

      if (response.ok) {
        setSuccessMessage("Demo scheduled successfully!");
        const demo_id = data.demo_id;
        const email = formData.demo_reciever_email;

        if (demo_id && email) {
          setTimeout(() => {
            history.push(
              `/scheduled_demo/${demo_id}?email=${encodeURIComponent(email)}`
            );
          }, 800);
        }

        setFormData({ demo_reciever_email: "", demo_time: "", phone_no:"" });
      } else {
        setError(data.message || "Failed to schedule demo. Please try again.");
      }
    } catch (err) {
      setError("Network error. Please try again later.");
      console.error("Error submitting form:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.demoWrap}>
      <div className={styles.container}>
        <h3 className={styles.heading}>Schedule a Demo</h3>

        {error && <p className={styles.error}>{error}</p>}
        {successMessage && <p className={styles.success}>{successMessage}</p>}

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.formGroup}>
            <label htmlFor="email">Email:</label>
            <div className={styles.inputWrapper}>
              <input
                type="email"
                name="demo_reciever_email"
                placeholder="Receiver Email"
                value={formData.demo_reciever_email}
                onChange={handleChange}
                required
                disabled={loading}
                className={styles.input}
              />
              <HiOutlineMail className={styles.inputIcon} />
            </div>
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="demo_time">Date & Time:</label>
            <div className={styles.inputWrapper}>
              <input
                ref={inputRef}
                type="datetime-local"
                name="demo_time"
                value={formData.demo_time}
                onChange={handleChange}
                required
                disabled={loading}
                className={styles.input}
                min={new Date().toISOString().slice(0, 16)}
              />
              <span
                className={styles.customIcon}
                onClick={() => !loading && inputRef.current?.showPicker()}
              >
                <LuCalendar className={styles.inputIcon} />
              </span>
            </div>
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="phone_no">Phone No</label>
            <div className={styles.inputWrapper}>
              <input
                // ref={inputRef}
                type="tel"
                name="phone_no"
                value={formData.phone_no}
                onChange={handleChange}
                required
                disabled={loading}
                className={styles.input}
                // min={new Date().toISOString().slice(0, 16)}
              />
                  <LuPhone className={styles.inputIcon} />

            </div>
          </div>

          <button
            type="submit"
            className={styles.button}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Schedule Demo"}
          </button>
        </form>
      </div>
    </div>
  );
}
